// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManageLocation-containerWith-hqJbv {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.ManageLocation-container-ffOWo {
    max-width: 100%;
}

/* Text - Start */

.ManageLocation-subText-owx1B {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.ManageLocation-navigationLink-v9IRK a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.ManageLocation-navigationLink-v9IRK a:hover,
.ManageLocation-navigationLink-v9IRK a:focus,
.ManageLocation-navigationLink-v9IRK a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.ManageLocation-noPadding-e6vEf {
    padding: 0;
}

.ManageLocation-heading-ORHPx {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.ManageLocation-widthInner-_1Qx9 {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.ManageLocation-noMargin-qL7Ye {
    margin: 0;
}

.ManageLocation-formControlInputTable-idHrY {
    border: none;
    width: 100px;
    height: auto;
}

.ManageLocation-backBtn-XCto8 {
    margin-left: 15px;
    display: inline-block;
}

.ManageLocation-backBtn-XCto8:active,
.ManageLocation-backBtn-XCto8:hover,
.ManageLocation-backBtn-XCto8:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.ManageLocation-textAlignRight-CiFf3 {
    text-align: right;
}

.ManageLocation-displayInlineBlock-i5Z0F {
    display: inline-block;
}

.ManageLocation-displayBlock-KCQRn {
    display: block;
}

.ManageLocation-countryCode-X9UfW {
    width: 15%;
    vertical-align: top;
}

.ManageLocation-vtrMiddle-dhuVF {
    vertical-align: middle;
}

/* commonCss */

.ManageLocation-editIcon-iXPO9 {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.ManageLocation-iconBtn-xSZyE,
.ManageLocation-iconBtn-xSZyE:hover,
.ManageLocation-iconBtn-xSZyE:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.ManageLocation-profileImg-lw8t1 {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.ManageLocation-profileImgSection-_gF8s {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.ManageLocation-profileImgWidth-tSngS {
    margin: 0;
    max-width: 100% !important;
}

.ManageLocation-searchInput-s6aD_ {
    width: 100%;
    max-width: 320px;
}

.ManageLocation-backgroundImg-Asugz {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.ManageLocation-exportDisplay-HLvxw {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.ManageLocation-exportTextSection-o81k6 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.ManageLocation-exportText-JYykY {
    display: inline-block;
    padding-right: 5px;
}

.ManageLocation-exportTextContainer-zdyG9 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.ManageLocation-vtrTextBottom-hlC0x {
    vertical-align: text-bottom;
}

.ManageLocation-exportImg-nm1PT {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.ManageLocation-noLink-KqRJy,
.ManageLocation-noLink-KqRJy:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.ManageLocation-singleCard-y7MQQ {
    width: 500px;
    margin: 0 auto;
}

.ManageLocation-defaultIcon-YF8jt {
    background-size: 50px;
}

.ManageLocation-assignProviderSearchInput-mKOdl {
    width: 100%;
    max-width: 324px;
}

.ManageLocation-searchGroupContainer-RFIsa {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .ManageLocation-searchGroupContainer-RFIsa {
        width: 100%;
    }

}

.ManageLocation-card-qZsRC {
    border: 0;
    margin: 18px 0;
    border-radius: 0px;
    background: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    padding: 25px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.ManageLocation-cardOne-ztO7F {
    border: 0;
    margin: 18px 0;
    -webkit-box-shadow: 0 6px 0 0 rgba(0, 0, 0, .01), 0 15px 32px 0 rgba(0, 0, 0, .06);
            box-shadow: 0 6px 0 0 rgba(0, 0, 0, .01), 0 15px 32px 0 rgba(0, 0, 0, .06);
    border-radius: 4px;
    background: #fff;
    padding: 25px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    border-radius: 25px;
    border-top-right-radius: 0;
    border-bottom-left-radius: 0;
}

.ManageLocation-buttonWidth-bMr0H {
    width: 200px;
}

.ManageLocation-fullWidth-C8cd9 {
    width: 100% !important;
}

.ManageLocation-passwordSection-JHHu6 {
  margin: 0 auto;
  width: 100%;
  max-width: 520px;
  background: #fff;
  border-radius: 10px;
  padding: 25px 20px;
  -webkit-box-shadow: 0 1px 15px 3px #2d3d5126;
          box-shadow: 0 1px 15px 3px #2d3d5126;
}

.ManageLocation-subtext-QSHcw {
  color: var(--secondary-foreground);
  margin: 0;
  font-size: 14px;
  margin-top: 6px;
}

.ManageLocation-searchLocation-WQC3U {
  position: relative;
  margin-top: 18px;
}

@media screen and (max-width: 767px) {
  .ManageLocation-passwordSection-JHHu6 {
    padding: 25px 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/SiteAdmin/AdminCommon.css","webpack://./src/components/SiteAdmin/ManageLocation/ManageLocation.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kFAA0E;YAA1E,0EAA0E;IAC1E,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,mBAAmB;IACnB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AC3BA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,4CAAoC;UAApC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}",".card {\n    border: 0;\n    margin: 18px 0;\n    border-radius: 0px;\n    background: #fff;\n    display: flex;\n    justify-content: space-between;\n    padding: 25px;\n    align-items: center;\n}\n\n.cardOne {\n    border: 0;\n    margin: 18px 0;\n    box-shadow: 0 6px 0 0 rgba(0, 0, 0, .01), 0 15px 32px 0 rgba(0, 0, 0, .06);\n    border-radius: 4px;\n    background: #fff;\n    padding: 25px;\n    display: flex;\n    flex-direction: column;\n    border-radius: 25px;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.buttonWidth {\n    width: 200px;\n}\n\n.fullWidth {\n    width: 100% !important;\n}","@import '../../../components/Common.css';\n@import '../AdminCommon.css';\n\n\n.passwordSection {\n  margin: 0 auto;\n  width: 100%;\n  max-width: 520px;\n  background: #fff;\n  border-radius: 10px;\n  padding: 25px 20px;\n  box-shadow: 0 1px 15px 3px #2d3d5126;\n}\n\n.subtext {\n  color: var(--secondary-foreground);\n  margin: 0;\n  font-size: 14px;\n  margin-top: 6px;\n}\n\n.searchLocation {\n  position: relative;\n  margin-top: 18px;\n}\n\n@media screen and (max-width: 767px) {\n  .passwordSection {\n    padding: 25px 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `ManageLocation-containerWith-hqJbv`,
	"container": `ManageLocation-container-ffOWo`,
	"subText": `ManageLocation-subText-owx1B`,
	"navigationLink": `ManageLocation-navigationLink-v9IRK`,
	"noPadding": `ManageLocation-noPadding-e6vEf`,
	"heading": `ManageLocation-heading-ORHPx`,
	"widthInner": `ManageLocation-widthInner-_1Qx9`,
	"noMargin": `ManageLocation-noMargin-qL7Ye`,
	"formControlInputTable": `ManageLocation-formControlInputTable-idHrY`,
	"backBtn": `ManageLocation-backBtn-XCto8`,
	"textAlignRight": `ManageLocation-textAlignRight-CiFf3`,
	"displayInlineBlock": `ManageLocation-displayInlineBlock-i5Z0F`,
	"displayBlock": `ManageLocation-displayBlock-KCQRn`,
	"countryCode": `ManageLocation-countryCode-X9UfW`,
	"vtrMiddle": `ManageLocation-vtrMiddle-dhuVF`,
	"editIcon": `ManageLocation-editIcon-iXPO9`,
	"iconBtn": `ManageLocation-iconBtn-xSZyE`,
	"profileImg": `ManageLocation-profileImg-lw8t1`,
	"profileImgSection": `ManageLocation-profileImgSection-_gF8s`,
	"profileImgWidth": `ManageLocation-profileImgWidth-tSngS`,
	"searchInput": `ManageLocation-searchInput-s6aD_`,
	"backgroundImg": `ManageLocation-backgroundImg-Asugz`,
	"exportDisplay": `ManageLocation-exportDisplay-HLvxw`,
	"exportTextSection": `ManageLocation-exportTextSection-o81k6`,
	"exportText": `ManageLocation-exportText-JYykY`,
	"exportTextContainer": `ManageLocation-exportTextContainer-zdyG9`,
	"vtrTextBottom": `ManageLocation-vtrTextBottom-hlC0x`,
	"exportImg": `ManageLocation-exportImg-nm1PT`,
	"noLink": `ManageLocation-noLink-KqRJy`,
	"singleCard": `ManageLocation-singleCard-y7MQQ`,
	"defaultIcon": `ManageLocation-defaultIcon-YF8jt`,
	"assignProviderSearchInput": `ManageLocation-assignProviderSearchInput-mKOdl`,
	"searchGroupContainer": `ManageLocation-searchGroupContainer-RFIsa`,
	"card": `ManageLocation-card-qZsRC`,
	"cardOne": `ManageLocation-cardOne-ztO7F`,
	"buttonWidth": `ManageLocation-buttonWidth-bMr0H`,
	"fullWidth": `ManageLocation-fullWidth-C8cd9`,
	"passwordSection": `ManageLocation-passwordSection-JHHu6`,
	"subtext": `ManageLocation-subtext-QSHcw`,
	"searchLocation": `ManageLocation-searchLocation-WQC3U`
};
module.exports = ___CSS_LOADER_EXPORT___;
